import styled from '@emotion/styled';

export const ChartToolbar = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.5rem',
  alignItems: 'center',
  marginBottom: 0,
});

export const ChartToolbarTrailing = styled.div({
  marginLeft: 'auto',
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
});
